/*
  Product details: tabs from 769px up, accordion below (sections/main-product-tabs.liquid,
  "Tabs, accordion on mobile"). The items are <details>; on desktop the tab bar opens
  one at a time and the CSS hides the summaries.
*/
class PdpDetailsTabs extends HTMLElement {
  connectedCallback() {
    this.buttons = [...this.querySelectorAll('.pdp-details-tabs__bar > button')];
    this.items = [...this.querySelectorAll('details.hdt-product-accordion__item')];
    this.desktop = window.matchMedia('(min-width: 769px)');
    this.buttons.forEach((button, index) => button.addEventListener('click', () => this.select(index)));
    this.desktop.addEventListener('change', () => this.sync());
    this.sync();
  }

  // On desktop exactly one item is open: keep the open one, else the first.
  sync() {
    if (!this.desktop.matches) return;
    const open = this.items.findIndex((item) => item.open);
    this.select(open < 0 ? 0 : open);
  }

  select(index) {
    this.items.forEach((item, n) => {
      item.open = n === index;
      item.querySelector('summary')?.setAttribute('aria-expanded', String(n === index));
    });
    this.buttons.forEach((button, n) => button.setAttribute('aria-current', String(n === index)));
  }
}

if (!customElements.get('pdp-details-tabs')) customElements.define('pdp-details-tabs', PdpDetailsTabs);
